import React from 'react';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import { WidgetProps, DEFAULT_BUTTON_TEXT } from '../shared';

import {
  MobilePhoneNumberInput,
  MobilePhoneNumberButton,
  PhoneNumberWrapper
} from './MobilePhoneNumberWidget.styles';

export function MobilePhoneNumberWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  buttonText = DEFAULT_BUTTON_TEXT,
  buttonContent,
  inputProps
}: WidgetProps) {
  return (
    <PhoneNumberWrapper flexDirection="row">
      <MobilePhoneNumberInput data-e2e="phone-number" {...inputProps} />
      <MobilePhoneNumberButton
        type="submit"
        cfButtonColor={buttonColor as CFColorTokenProp}
        cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
        data-e2e="btn-getting-started"
        data-testid="btn-getting-started"
      >
        {buttonContent || buttonText}
      </MobilePhoneNumberButton>
    </PhoneNumberWrapper>
  );
}
